export function sortCreatedDate<T extends Remote.ChangeService>(a: T, b: T): number {
  const aDate = a.created;
  const bDate = b.created;

  if (aDate && bDate) {
    if (aDate > bDate) {
      return -1;
    } else if (aDate < bDate) {
      return 1;
    }
  }

  return 0;
}

export const isDev = () => {
  const host = window.location.host;
  return host.includes("dev") || host.includes("localhost");
};

// eslint-disable-next-line
export const isEmpty = (value: any): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};
